import React from 'react';
import "@/App.css";
import RootRoute from './pages/RootRoute';
import ShortLinkRedirect from './pages/ShortLinkRedirect';
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from './components/ui/sonner';
import { AuthProvider } from './contexts/AuthContext';
import AppHeader from './components/AppHeader';
import HomePage from './pages/HomePage';
import LandingPage from './pages/LandingPage';
import OnboardingPage from './pages/OnboardingPage';
import CatalogPage from './pages/CatalogPage';
import ProductDetailPage from './pages/ProductDetailPage';
import AdminPage from './pages/AdminPage';
import CartPage from './pages/CartPage';
import AccountPage from './pages/AccountPage';
import SuperAdminPage from './pages/SuperAdminPage';
import ShopSettingsPage from './pages/ShopSettingsPage';
import OrdersPage from './pages/OrdersPage';
import FlyerPage from './pages/FlyerPage';
import PricingPage from './pages/PricingPage';
import OrderTrackingPage from './pages/OrderTrackingPage';
import ShopPublicPage from './pages/ShopPublicPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import ShopFlyersArchivePage from './pages/ShopFlyersArchivePage';
import AdminDashboardPage from './pages/AdminDashboardPage';
import PaymentSuccessPage from './pages/PaymentSuccessPage';
import ShareSimulationPage from './pages/ShareSimulationPage';
import TestProfilesPage from './pages/TestProfilesPage';
import PlatformSettingsPage from './pages/PlatformSettingsPage';
import AIPricingPage from './pages/AIPricingPage';
import ImpersonationBanner from './components/ImpersonationBanner';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppLayout />
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}

function AppLayout() {
  const location = useLocation();
  const isMarketing = location.pathname === '/' || location.pathname.startsWith('/apri-negozio');
  const wrapperClass = isMarketing
    ? 'min-h-screen bg-[#FDFBF7] relative'
    : 'min-h-screen bg-[#FDFBF7] max-w-2xl mx-auto relative';
  return (
    <div className={wrapperClass}>
      <ImpersonationBanner />
      <AppHeader />
      <Routes>
        <Route path="/" element={<RootRoute />} />
        <Route path="/apri-negozio" element={<OnboardingPage />} />
        <Route path="/home-demo" element={<HomePage />} />
        <Route path="/catalogo" element={<CatalogPage />} />
        <Route path="/prodotto/:id" element={<ProductDetailPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/carrello" element={<CartPage />} />
        <Route path="/account" element={<AccountPage />} />
        <Route path="/superadmin" element={<SuperAdminPage />} />
        <Route path="/superadmin/test-profiles" element={<TestProfilesPage />} />
        <Route path="/superadmin/impostazioni" element={<PlatformSettingsPage />} />
        <Route path="/piani-ai" element={<AIPricingPage />} />
        <Route path="/negozio/impostazioni" element={<ShopSettingsPage />} />
        <Route path="/ordini" element={<OrdersPage />} />
        <Route path="/volantino/:flyerId" element={<FlyerPage />} />
        <Route path="/prezzi" element={<PricingPage />} />
        <Route path="/tracking" element={<OrderTrackingPage />} />
        <Route path="/tracking/:orderId" element={<OrderTrackingPage />} />
        <Route path="/negozio/:slug" element={<ShopPublicPage />} />
        <Route path="/negozio/:slug/archivio" element={<ShopFlyersArchivePage />} />
        <Route path="/dashboard" element={<AdminDashboardPage />} />
        <Route path="/pagamento/successo" element={<PaymentSuccessPage />} />
        <Route path="/simulazione-condivisione" element={<ShareSimulationPage />} />
        <Route path="/reset-password/:token" element={<ResetPasswordPage />} />
        <Route path="/forgot-password" element={<Navigate to="/account?forgot=1" replace />} />
        <Route path="/l/:code" element={<ShortLinkRedirect />} />
      </Routes>
    </div>
  );
}

export default App;
